module.exports = __webpack_public_path__ + "static/media/vpsoci-retention-snappy.69e07155.png";